var _polyline, _polyline2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "stroke-color-main",
    points: "51.07 156.278 24.254 156.278 24.254 78.282 175.746 78.282 175.746 156.278 147.737 156.278"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "stroke-color-main",
    points: "52.375 73.537 52.375 22.968 147.625 22.968 147.625 73.537"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fill-color-main",
    x: 150.772,
    y: 91.39,
    width: 8.979,
    height: 8.979
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "stroke-color-main",
    x: 52.375,
    y: 126.463,
    width: 95.25,
    height: 50.569
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.a5afa7c7a82852bb4bc7d41d045755dc.svg";
export { ForwardRef as ReactComponent };